<template>
    <div class="tabs-container">
        <DxTabs :data-source="tabs" :selected-index.sync="selectedIndex" @option-changed="onTabChanged"
            :item-template="tabTemplate" />
        <div v-if="selectedIndex === 0">
            <GridBilanturi @select-bilant="onBilantSelected" />
        </div>
        <div v-if="selectedIndex === 1">
            <GridFormuleRanduri :bilant="selectedBilant"  @back="selectedIndex = 0" />
        </div>
    </div>
</template>
<script>
import { DxTabs } from 'devextreme-vue/tabs';
import GridBilanturi from './GridBilanturi.vue';
import GridFormuleRanduri from './GridFormuleRanduri.vue';
export default {
    components: {
        DxTabs,
        GridBilanturi,
        GridFormuleRanduri
    },
    data() {
        return {
            tabs: [
                { text: 'Bilanturi' },
                { text: 'Bilanturi Rand' },
            ],
            selectedIndex: 0,
            selectedBilant: null ,
        };
    },
    methods: {

        onTabChanged(e) {
            this.selectedIndex = e.component.option('selectedIndex');
        },
        tabTemplate(itemData) {
            return `<div>${itemData.text}</div>`;
        },
        onBilantSelected(bilant) {
            this.selectedBilant = bilant;
            this.selectedIndex = 1;
        }
    }

};
</script>
<style scoped></style>